'use client'

import React from 'react';
import { Stack, Container, Icon, Box, Flex, Text, Heading, SimpleGrid, useColorModeValue } from '@chakra-ui/react';
import { RiSecurePaymentFill } from "react-icons/ri";
import { MdVerified } from "react-icons/md";
import { LuCalendarSearch } from "react-icons/lu";
import { IoMdLock } from "react-icons/io";
import { IoMdCamera } from "react-icons/io";


export default function StatsGridWithImage() {
    const stats = [
        {
            title: '500+',
            content: 'Professional photographers available for instant booking nationwide.',
            icon: IoMdCamera,
            iconBg: useColorModeValue('yellow.100', 'yellow.900'),
            iconColor: useColorModeValue('yellow.500', 'yellow.200'),
          },
          {
            title: '24/7',
            content: 'Bookings for any occasion, whether planned or last-minute.',
            icon: LuCalendarSearch,
            iconBg: useColorModeValue('green.100', 'green.900'),
            iconColor: useColorModeValue('green.500', 'green.200'),
          },
          {
            title: '1000+',
            content: 'Verified reviews ensuring trust and transparency between clients and photographers.',
            icon: MdVerified,
            iconBg: useColorModeValue('purple.100', 'purple.900'),
            iconColor: useColorModeValue('purple.500', 'purple.200'),
          },
          {
            title: '100%',
            content: 'PCI DSS compliant, Secure payments via Stripe, and released upon completion and review.',
            icon: RiSecurePaymentFill,
            iconBg: useColorModeValue('blue.100', 'blue.900'),
            iconColor: useColorModeValue('blue.500', 'blue.200'),
          },
    ];
      
    const bgColor = useColorModeValue('white', 'black');
    const textColor = useColorModeValue('black', 'white');
    const headingColor = useColorModeValue('black', 'white');
    
    return (
    <Box bg={bgColor} position={'relative'}>
      <Flex
        flex={1}
        zIndex={0}
        display={{ base: 'none', lg: 'flex' }}
        backgroundImage="url('/PapiMotion.jpg')" // Replace with your relevant image path
        backgroundSize={'cover'}
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        position={'absolute'}
        width={'50%'}
        insetY={0}
        right={0}>
        <Flex
          bgGradient={useColorModeValue( 'linear(to-r, white 10%, transparent)', 'linear(to-r, black 10%, transparent)')}
          w={'full'}
          h={'full'}
        />
      </Flex>
      <Container maxW={'7xl'} zIndex={10} position={'relative'}>
        <Stack direction={{ base: 'column', lg: 'row' }}>
          <Stack
            flex={1}
            color={textColor}
            justify={{ lg: 'center' }}
            py={{ base: 4, md: 20, xl: 60 }}>
            <Box mb={{ base: 8, md: 20 }} textAlign="center">
              <Text
                fontFamily={'heading'}
                fontWeight={700}
                textTransform={'uppercase'}
                mb={3}
                fontSize={'xl'}
                bgClip='text'
                bgGradient={[
                    'linear(to-r, #FF0080, #7928CA 70%)',   
                ]}
                _hover={{bgGradient: 'linear(to-r, red.500, purple.500 50%)'}} 
                >
                On-Demand Photography
              </Text>
              <Heading color={headingColor} mb={5} fontSize={{ base: '3xl', md: '5xl' }}>
                Connecting You to Photographers in Real-Time
              </Heading>
              <Text fontSize={'xl'} color={textColor}>
                With PapiRazzi, you can instantly book a professional photographer for any occasion. Whether last-minute or planned ahead, we ensure trust between customers and photographers with secure payments and transparent reviews.
              </Text>
            </Box>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} >
              {stats.map((stat, index) => (
                <Stack spacing={4} key={index}>
                <Box >
                  <Flex align="center">
                    <Flex
                      w={8}
                      h={8}
                      align={'center'}
                      justify={'center'}
                      rounded={'full'}
                      bg={stat.iconBg}
                      mr={2}
                      position="relative"
                      top="-6px"  
                    >
                      <Icon as={stat.icon} color={stat.iconColor} w={5} h={5} />
                    </Flex>
                    <Text fontFamily={'heading'} fontSize={'3xl'} color={headingColor} mb={3}>
                      {stat.title}
                    </Text>
                  </Flex>
                  <Text fontSize={'xl'} color={textColor}>
                    {stat.content}
                  </Text>
                </Box>
              </Stack>
              
              
              ))}
            </SimpleGrid>
          </Stack>
          <Flex flex={1} />
        </Stack>
      </Container>
    </Box>
  );
}


/*
import {
    Container,
    SimpleGrid,
    Image,
    Flex,
    Heading,
    Text,
    Stack,
    StackDivider,
    Icon,
    useColorModeValue,
  } from '@chakra-ui/react';
  //import { IoAnalyticsSharp, IoLogoBitcoin, IoSearchSharp } from 'react-icons/io5';
  import { RiSecurePaymentFill } from "react-icons/ri";
  import { MdVerified } from "react-icons/md";
  import { LuCalendarSearch } from "react-icons/lu";



  
  // Feature component in JavaScript
  const Feature = ({ text, icon, iconBg }) => {
    return (
      <Stack direction={'row'} align={'center'}>
        <Flex w={8} h={8} align={'center'} justify={'center'} rounded={'full'} bg={iconBg}>
          {icon}
        </Flex>
        <Text fontWeight={600}>{text}</Text>
      </Stack>
    );
  };
  
  export default function SplitWithImage() {
    return (
      <Container maxW={'5xl'} py={12}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          <Stack spacing={4}>
            <Text
              textTransform={'uppercase'}
              color={'blue.400'}
              fontWeight={600}
              fontSize={'sm'}
              bg={useColorModeValue('blue.50', 'blue.900')}
              p={2}
              alignSelf={'flex-start'}
              rounded={'md'}>
              Our Mission
            </Text>
            <Heading>Bringing Photographers and Clients Together</Heading>
            <Text color={'gray.500'} fontSize={'lg'}>
            Papirazzi connects you with professional photographers for on-demand services.
            Whether you need last-minute or pre-planned bookings, we ensure trust and quality from booking to delivery.
            </Text>
            <Stack
              spacing={4}
              divider={
                <StackDivider borderColor={useColorModeValue('gray.100', 'gray.700')} />
              }>
              <Feature
                icon={<Icon as={RiSecurePaymentFill} color={'yellow.500'} w={5} h={5} />}
                iconBg={useColorModeValue('yellow.100', 'yellow.900')}
                text={'Stripe Payments for Secure Transactions'}
              />
              <Feature
                icon={<Icon as={MdVerified} color={'green.500'} w={5} h={5} />}
                iconBg={useColorModeValue('green.100', 'green.900')}
                text={'Verified Professional Photographers'}
              />
              <Feature
                icon={<Icon as={LuCalendarSearch} color={'purple.500'} w={5} h={5} />}
                iconBg={useColorModeValue('purple.100', 'purple.900')}
                text={'On-Demand & Scheduled Services'}
              />
            </Stack>
          </Stack>
          <Flex>
            <Image
              rounded={'md'}
              alt={'feature image'}
              src={
                'https://images.unsplash.com/photo-1554200876-56c2f25224fa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
              }
              objectFit={'cover'}
            />
          </Flex>
        </SimpleGrid>
      </Container>
    );
  }
  

*/